import { render, staticRenderFns } from "./UserComment.vue?vue&type=template&id=49d0bcc6&scoped=true&"
import script from "./UserComment.vue?vue&type=script&lang=js&"
export * from "./UserComment.vue?vue&type=script&lang=js&"
import style0 from "./UserComment.vue?vue&type=style&index=0&id=49d0bcc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d0bcc6",
  null
  
)

export default component.exports